import { render, staticRenderFns } from "./StockReportForSj.vue?vue&type=template&id=675aa6ee&scoped=true&"
import script from "./StockReportForSj.vue?vue&type=script&lang=js&"
export * from "./StockReportForSj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675aa6ee",
  null
  
)

export default component.exports